
import Tabbar from 'vux/src/components/tabbar/tabbar.vue'
import TabbarItem from 'vux/src/components/tabbar/tabbar-item.vue'

export default {
components: {
Tabbar,
TabbarItem
},
methods: {
jump: function (e) {
this.$router.push(e);
}
},
watch:{
'$route' (to, from) {

var ontabbar = document.getElementsByClassName("tabbar-div-on");
var tabbar = document.getElementsByClassName("tabbar-div");
for(var i=0;i<ontabbar.length;i++){
ontabbar[i].classList.remove("tabbar-div-on");
}

if(this.$route.path.indexOf("Index") != "-1"){
tabbar[0].classList.add("tabbar-div-on");
}else if(this.$route.path.indexOf("Class") != "-1"){
tabbar[1].classList.add("tabbar-div-on");
}else if(this.$route.path.indexOf("Resource") != "-1"){
tabbar[2].classList.add("tabbar-div-on");
}else if(this.$route.path.indexOf("Personal") != "-1"){
tabbar[3].classList.add("tabbar-div-on");
}
}
}
}



// WEBPACK FOOTER //
// ./src/components/FooterCpt.vue